import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { CotacaoTable } from '../components/cotacao/CotacaoTable';
import { NovaCotacaoModal } from '../components/cotacao/NovaCotacaoModal';
import { CalculoModal } from '../components/calculo/CalculoModal';
import { CalculoData } from '../services/calculoService';

export const Cotacoes: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedCalculo, setSelectedCalculo] = useState<CalculoData | undefined>(undefined);
  const [showCalculoModal, setShowCalculoModal] = useState(false);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
                Gestão de Cálculos e Cotações
              </h1>
              <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
                Gerencie os cálculos e compare as cotações recebidas
              </p>
            </div>

            <button
              onClick={() => setShowModal(true)}
              className="px-3 py-1.5 text-xs font-medium text-white rounded-md hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 transition-opacity"
              style={{ backgroundColor: '#7A61B2' }}
            >
              + Nova Cotação
            </button>
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <CotacaoTable 
              onEdit={(calculo) => {
                setSelectedCalculo(calculo);
                setShowCalculoModal(true);
              }}
              onRefresh={() => {
                setRefreshTrigger(prev => prev + 1);
              }}
              activeId={null}
              refreshTrigger={refreshTrigger}
            />
          </div>
        </div>
        
        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>

      {/* Modal Nova Cotação */}
      <NovaCotacaoModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={() => {
          setRefreshTrigger(prev => prev + 1);
        }}
      />

      {/* Modal de Visualização/Edição de Cálculos */}
      <CalculoModal
        calculo={selectedCalculo}
        isOpen={showCalculoModal}
        onClose={() => {
          setShowCalculoModal(false);
          setSelectedCalculo(undefined);
        }}
        onEdit={(calculo) => {
          // Mantém o modal aberto para editar
          setSelectedCalculo(calculo);
        }}
        onDelete={() => {
          setShowCalculoModal(false);
          setSelectedCalculo(undefined);
          setRefreshTrigger(prev => prev + 1);
        }}
        onRefresh={() => {
          setRefreshTrigger(prev => prev + 1);
        }}
      />
    </div>
  );
};
